export const pvJahresvergleich = {
    PvJahresvergleichClass: {
        url: "PvJahresvergleich/1",
        defaultSegment: "PvJahresvergleich",
        forceRefresh: false,
        receiveType: 'RECEIVE_PvJahresvergleich_pvJahresvergleichReducer'
    },
    SollVsIstClass: {
        url: "PvJahresvergleich/1/sollVsIst",
        defaultSegment: "PvJahresvergleich",
        forceRefresh: false,
        // WICHTIG: Eigenen Reducer-Namen verwenden damit globalAction's isLoaded-Check
        // nicht mit dem Haupt-Request kollidiert und abbricht.
        receiveType: 'RECEIVE_SollVsIst_pvJahresvergleichSollVsIstReducer'
    }
};
